import React from "react";
import "./CaseStudies.css";
import { FaArrowRight } from "react-icons/fa";

const ProjectCard = ({ project, index, onClick }) => {
  if (project.isPromo) {
    return (
      <div
        className="cs-dapp-card cs-card-promo animate-fadeInUp"
        style={{ animationDelay: `${index * 0.08}s`, cursor: "pointer" }}
        onClick={() => onClick && onClick(project)}
      >
        <div className="cs-promo-content">
          <span className="cs-promo-badge">✦ Featured Ecosystem</span>
          <h2 className="cs-promo-title">{project.description}</h2>
          <div className="cs-promo-action">
            <span>Explore Now</span>
            <i className="fas fa-arrow-right" style={{ fontSize: "14px" }}></i>
          </div>
        </div>
      </div>
    );
  }

  // Intelligent Fallback Logic
  const getProjectImage = () => {
    if (
      !project.image ||
      project.image.includes("placeholder") ||
      (project.image.includes("cryptologos.cc") &&
        project.title === "SynFutures")
    ) {
      return index % 2 === 0
        ? "/assets/img/case-studies/web3_sphere.png"
        : "/assets/img/case-studies/web3_blue.png";
    }
    return project.image.startsWith("http") || project.image.startsWith("/")
      ? project.image
      : `/${project.image}`;
  };

  const projectImg = getProjectImage();

  return (
    <div
      className="cs-dapp-card cs-card-enterprise animate-fadeInUp"
      style={{
        animationDelay: `${index * 0.08}s`,
        cursor: onClick ? "pointer" : "default",
      }}
      onClick={() => onClick && onClick(project)}
    >
      <div className="cs-card-inner">
        <div
          className="cs-card-media-frame"
          style={{ height: "190px", borderRadius: "16px" }}
        >
          <img
            src={projectImg}
            alt={project.title}
            className="cs-enterprise-asset"
          />
        </div>

        <div className="cs-card-enterprise-info">
          <div className="cs-info-top">
            {project.category && (
              <span className="cs-category-tag">{project.category}</span>
            )}
          </div>

          <h3 className="cs-enterprise-title">{project.title}</h3>

          {project.description && (
            <p className="cs-card-description">{project.description}</p>
          )}
        </div>

        <div className="cs-card-footer">
          <div className="cs-card-chains">
            {project.chains &&
              project.chains.slice(0, 3).map((chain, idx) => (
                <span key={idx} className="cs-chain-pill">
                  {project.icons && project.icons[idx] && (
                    <img
                      src={project.icons[idx]}
                      alt={chain}
                      onError={(e) => {
                        e.target.style.display = "none";
                      }}
                    />
                  )}
                  {chain}
                </span>
              ))}
          </div>
          <div className="cs-card-arrow">
            <FaArrowRight size={15} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
